const ABProcessTaskServiceCore = require("../../../core/process/tasks/ABProcessTaskServiceCore");
module.exports = class ABProcessTaskService extends ABProcessTaskServiceCore {};
